
import { Vue, Component, Prop } from 'vue-property-decorator'
import { RawLocation } from 'vue-router'
import RecaptchaComponent from '@/components/auth/RecaptchaComponent.vue'

import { IAuthService } from '@/services/auth/IAuthService'
import { IUserService } from '@/services/user/IUserService'
import { ITranslationService } from '@/services/translation/ITranslationService'
import LicenseDialog from '@/components/auth/LicenseDialog.vue'

const enum AuthErrors {
  BadCredentials = 'dialogs.auth.errors.bad_credentials',
  ConnectionIssue = 'dialogs.auth.errors.connection_issue',
}

@Component({
  components: {
    RecaptchaComponent,
    LicenseDialog,
  },
})
export default class AuthView extends Vue {
  @Prop({ type: [Object, String] }) readonly to?: RawLocation

  username = ''
  password = ''
  isLoading = false

  hasCaptcha = false
  captchaSolved = false
  error: AuthErrors | null = null
  showLicense = false

  created(): void {
    const authenticationService = this.$services.get<IAuthService>('auth')
    this.hasCaptcha = authenticationService.hasCaptchaConfigured()
  }

  async login(): Promise<void> {
    const userService = this.$services.get<IUserService>('user')
    const authService = this.$services.get<IAuthService>('auth')

    try {
      this.isLoading = true
      const authenticated = await authService.login(this.username, this.password)
      if (authenticated) {
        let currentUser = await userService.getCurrentUser()
        if (currentUser.language) {
          this.useLanguage(currentUser.language)
        }
        if (currentUser.acceptedLicenseAgreement === false) {
          this.showLicense = true
        } else {
          this.$router.push(this.to ? this.to : { name: 'Home' })
        }
      } else {
        this.error = AuthErrors.BadCredentials
        this.isLoading = false
      }
      this.isLoading = false
    } catch (error) {
      this.error = AuthErrors.ConnectionIssue
      this.isLoading = false
      console.log(error)
    }
  }

  async useLanguage(code: string): Promise<void> {
    const translationService = this.$services.get<ITranslationService>('translation')
    translationService.useLanguage(code)
  }

  redirectUser(view: string): void {
    this.$router.push({ name: view })
  }

  onCaptchaUpdated(captchaResult: boolean): void {
    this.captchaSolved = captchaResult
  }

  closeLicenseDiaglog(): void {
    this.showLicense = false
  }

  get canSubmit(): boolean {
    const credentialsFilledIn = this.username.trim() !== '' && this.password.trim() !== ''
    return this.hasCaptcha ? credentialsFilledIn && this.captchaSolved : credentialsFilledIn
  }

  handleEnterKey(): void {
    if (this.canSubmit && !this.isLoading) {
      this.login()
    }
  }
}
